import { render, staticRenderFns } from "./OtherPath.vue?vue&type=template&id=1d36b507&"
import script from "./OtherPath.vue?vue&type=script&lang=js&"
export * from "./OtherPath.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports